import useFetch from "../../../hooks/useFetch";
import { toast } from "react-toastify";
toast.configure();

export const useUploadProfilePicture = (setProfileData) => {
  const { mutate: mutateProfileUpload } = useFetch(
    "addOrUpdateMentorProfileImage",
    {
      manual: true,
      method: "post",
      onSuccess: (data) => {
        setProfileData((prev) => ({ ...prev, photo: data?.photo }));
        toast.success("Profile picture upload successful", {
          position: toast.POSITION.TOP_CENTER,
        });
      },
      onError: () => {
        toast.error("Profile picture upload failed", {
          position: toast.POSITION.TOP_CENTER,
        });
      },
    }
  );

  const selectPhoto = (event) => {
    const formData = new FormData();
    formData.append("profile", event.target.files[0]);
    event.target.value = null;
    event.target.files = null;

    mutateProfileUpload({
      data: formData,
    });
  };

  return selectPhoto;
};
